import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {ClientSidePermissionContainerModel} from '../../../../../models/aggregates/permissions';
import {Core2Config} from '../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class ClientSideTenantPermissionService extends BaseApiTemplateService<ClientSidePermissionContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permissions';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permissions';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permissions';
    this.httpClient = http;
  }
}
